@if (userProfileImagePath) {
	<ae-profile-picture [src]="userProfileImagePath" />
}
@if (!userProfileImagePath) {
	<i class="fas fa-user-circle fa-3x"></i>
}
